export const TagType = {
  SMALL: 'small',
  SMALL_FAT: 'small_fat',
  MEDIUM: 'medium',
  LARGE: 'large',
};
